import script from "./TechnologyAssetsRepoTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyAssetsRepoTabs.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyAssetsRepoTabs.vue?vue&type=style&index=0&id=35ab98a4&lang=scss"

const __exports__ = script;

export default __exports__